export const Keys = {
    AuthUser: 'QualityWorx.AuthUser',
    AuthToken: 'QualityWorx.AuthToken',  
}